import {
  isContactSatisfied,
  type Contact,
  type ContactStrategy,
  type StepId,
} from "@autopic/shared";

interface DetailsContactFieldOptions {
  steps: StepId[];
  strategy: ContactStrategy;
  contact: Contact;
  requiredFields: string[];
  editingFromSummary: boolean;
}

export interface DetailsContactFieldVisibility {
  contactCapturedEarlier: boolean;
  showEmail: boolean;
  showPhone: boolean;
}

/**
 * Avoid asking for the same contact details twice in the normal journey.
 * Garage Hive can still require a missing field after availability is loaded,
 * and the summary's Change action intentionally exposes both fields for edits.
 */
export function getDetailsContactFieldVisibility({
  steps,
  strategy,
  contact,
  requiredFields,
  editingFromSummary,
}: DetailsContactFieldOptions): DetailsContactFieldVisibility {
  const contactIndex = steps.indexOf("contact");
  const detailsIndex = steps.indexOf("details");
  const contactCapturedEarlier =
    contactIndex >= 0 &&
    detailsIndex > contactIndex &&
    isContactSatisfied(strategy, contact);
  const required = new Set(requiredFields);
  const showCapturedFields = !contactCapturedEarlier || editingFromSummary;

  return {
    contactCapturedEarlier,
    showEmail:
      showCapturedFields || (required.has("contact_email") && !contact.email),
    showPhone:
      showCapturedFields || (required.has("contact_number") && !contact.phone),
  };
}
